import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"

export const TextInputWithLoaderWrap = styled.div`
  position: relative;

  & > .LoadingCircle {
    position: absolute;
    margin: 0 !important;
    left: auto !important;
    right: 5px !important;
    top: calc(50% - 10px) !important; /* for LoadingCircle sized at 20px  */
    display: ${(props) => (props.loading ? "block" : "none")};
  }
`

export const EmbedEditWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;

  .TextInput,
  .react-codemirror2 {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  ${(p) =>
    p.blockStyles
      ? `
        .TextInput__input input {
          color: ${p.blockStyles.styleAttributes.color};
          border-color: ${p.blockStyles.styleAttributes.color};
        }

        .Button.text {
          color: ${p.blockStyles.styleAttributes.color};
        }
      `
      : ""}
`

export const EmbedWrapper = styled(Content.Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  max-width: unset;
  width: 100%;
  margin: 0;

  // Center wrappers
  .EmbedBlockDisplay__container div {
    margin: 0 auto;
  }

  ${(p) =>
    p.aspect === "16:9"
      ? `
      aspect-ratio: 16 / 9;

      iframe {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        height: 100% !important;
      }

      // Disable existing responsive wrappers (ex: from iframely)
      .EmbedBlockDisplay__container div {
        position: unset !important;
      }
  `
      : ``}

  .BlockText {
    text-align: center;
  }
`
